// @flow weak
/*
100% bonkers component that acts like:

<span style="display:inline-block">some text that might be a little too long</span>

but if the text doesn't fit (because containing ancestors are restricting the
width), then it will add an ellipsis in the middle like this:

<span style="display:inline-block">some text... le too long</span>
*/

import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import _ from 'lodash';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax
import shallowEqual from 'shallowequal';

import { Duration } from '@zapier/theme';
import { Timeout } from '@zapier/common-components';

import Popover from 'app/common/components/Popover';
import PopoverMessage from 'app/common/components/PopoverMessage';
import { getRef, setRef } from 'app/common/utils/ReactUtils';

const styles = {
  textContainer: {
    display: 'inline-block',
    whiteSpace: 'no-wrap',
    position: 'relative',
    maxWidth: 'none',
  },
  hiddenText: {
    display: 'inline-block',
    visibility: 'hidden',
    pointerEvents: 'none',
    maxWidth: 'none',
  },
  hiddenEndText: {
    display: 'inline-block',
    visibility: 'hidden',
    position: 'absolute',
    top: 0,
    left: 0,
  },
};

/*
// Probably kind of expensive, but you have to walk back to find the parent where the text overflows.
const ancestorOverflowWidth = (node) => {
  const {parentNode} = node;

  if (!parentNode) {
    return 0;
  }
  if (isNaN(Number(parentNode.scrollWidth))) {
    return 0;
  }
  if (isNaN(Number(parentNode.clientWidth))) {
    return 0;
  }

  const overflowWidth = parentNode.scrollWidth - parentNode.clientWidth;
  console.log('check:', parentNode.scrollWidth, parentNode.clientWidth);

  // If we found clipping, we're done.
  if (overflowWidth > 0) {
    return overflowWidth;
  }

  const style = window.getComputedStyle(parentNode);
  // Once we've reached the element that is clipping, then we're done.
  if (style.overflowX === 'hidden') {
    return 0;
  }

  return ancestorOverflowWidth(parentNode);
};
*/

const TextOverflowMiddleEllipsis = createReactClass({
  displayName: 'TextOverflowMiddleEllipsis',
  mixins: [PureRenderMixin],

  getInitialState() {
    return {
      // Current measurements.
      textWidth: null,
      textEndWidth: null,
      overflowWidth: null,

      isFullTextPopoverOpen: false,
      isHoveringOverText: false,
    };
  },

  adjustSize() {
    // Ensures that numbers are converted to strings
    const value = _.toString(this.props.value);

    // Measure the container.
    const textNode = getRef(this, 'hiddenText');

    // Remove the maxWidth so we can properly measure. See note on webkit below.
    const oldMaxWidth = textNode.style.maxWidth;
    textNode.style.maxWidth = 'none';

    const textRect = textNode.getBoundingClientRect();
    const textWidth = textRect.right - textRect.left;

    // See if there's overflow.
    let overflowWidth = textWidth - this.props.maxWidth;
    if (overflowWidth < 0) {
      overflowWidth = 0;
    }

    // Set the end text.
    const approxCharWidth = textWidth / value.length;
    const fitWidth = textWidth - overflowWidth;
    const endLength = Math.floor((fitWidth * 0.45) / approxCharWidth);
    const endText = value.substring(value.length - endLength);
    const endTextNode = getRef(this, 'hiddenEndText');
    endTextNode.textContent = endText;

    // Measure the end text.
    const endTextRect = endTextNode.getBoundingClientRect();
    const endTextWidth = endTextRect.right - endTextRect.left;
    endTextNode.innerHTML = '';

    textNode.style.maxWidth = oldMaxWidth;

    this.setState({
      textWidth,
      overflowWidth,
      endTextWidth,
    });
  },

  componentDidMount() {
    this.adjustSize();
  },

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!shallowEqual(nextProps, this.props)) {
      this.setState({}, () => {
        this.adjustSize();
      });
    }
  },

  onMouseEnter() {
    this.setState({
      isHoveringOverText: true,
    });
  },

  onOpenFullTextPopover() {
    this.setState({
      isFullTextPopoverOpen: true,
    });
  },

  onMouseLeave() {
    this.setState({
      isFullTextPopoverOpen: false,
      isHoveringOverText: false,
    });
  },

  render() {
    let endLength = 0;
    let fitWidth;

    const value = this.props.value || '';

    if (value && this.state.overflowWidth > 0) {
      const approxCharWidth = this.state.textWidth / value.length;
      fitWidth = this.state.textWidth - this.state.overflowWidth;
      endLength = Math.floor((fitWidth * 0.45) / approxCharWidth);
    }

    const textContainerStyles = { ...styles.textContainer };
    const hiddenTextStyles = { ...styles.hiddenText };

    if (value && this.state.overflowWidth > 0) {
      // Do this so it acts like a normal inline-block, where other context can touch the end.
      textContainerStyles.maxWidth = `${this.state.textWidth -
        this.state.overflowWidth}px`;
      // This shouldn't have to be here, but webkit has some issues with
      // relative + hidden: see https://jsfiddle.net/justindeal/ta2owoay/4/
      hiddenTextStyles.maxWidth = `${this.state.textWidth -
        this.state.overflowWidth}px`;
    }

    return (
      <Popover>
        <span style={textContainerStyles}>
          <Timeout
            delay={Duration.tooltipTimeout.default}
            isWaiting={this.state.isHoveringOverText}
            onTimeout={this.onOpenFullTextPopover}
          />
          {!value || this.state.overflowWidth === null ? null : this.state
              .overflowWidth <= 0 ? (
            /* The text fits, just show it all. */
            <span style={{ position: 'absolute', top: 0, left: 0 }}>
              {value}
            </span>
          ) : (
            /* The text had to be split. */
            /* Need to find an accessible solution here. Probably show popup on focus? */
            <span
              onBlur={this.onMouseLeave}
              onFocus={this.onMouseEnter}
              onMouseEnter={this.onMouseEnter}
              onMouseLeave={this.onMouseLeave}
              role="button"
              tabIndex={0}
            >
              {/* The left half of the split text. */}
              <span
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: (fitWidth || 0) - this.state.endTextWidth,
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  whiteSpace: 'no-wrap',
                }}
              >
                {value}
              </span>
              {/* The right half of the split text. */}
              <span
                style={{
                  position: 'absolute',
                  top: 0,
                  left: (fitWidth || 0) - this.state.endTextWidth,
                  width: this.state.endTextWidth,
                  overflow: 'hidden',
                  whiteSpace: 'no-wrap',
                }}
              >
                {value.substring(value.length - endLength)}
              </span>
            </span>
          )}
          {/* Render the full text in a hidden span so we can measure it. */}
          <span ref={setRef(this, 'hiddenText')} style={hiddenTextStyles}>
            {value}
          </span>
          {/* Render the right half of the split text so we can measure it. */}
          <span
            ref={setRef(this, 'hiddenEndText')}
            style={styles.hiddenEndText}
          />
        </span>
        {!this.state.isFullTextPopoverOpen ? null : (
          <PopoverMessage>{value}</PopoverMessage>
        )}
      </Popover>
    );
  },
});

export default TextOverflowMiddleEllipsis;
